import { get_ClientModule2m5j3ywx3t162 as get_ClientModule } from './ClientModule.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  NothingSerializer3oixyyf77l4xt as NothingSerializer,
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  SetSerializert3lb0yy9iftr as SetSerializer,
  MapSerializer11kmegt3g5c1g as MapSerializer,
  MapEntrySerializer3oe1sx5ozvw2u as MapEntrySerializer,
  PairSerializer1d18kmsqyj4f as PairSerializer,
  TripleSerializer39fneesmgp1wy as TripleSerializer,
  serializer1cdzkc3mnhoc4 as serializer,
  serializer3u3hsxnenk49x as serializer_0,
  serializer1r0h5yakm679b as serializer_1,
  serializer36584sjyg5661 as serializer_2,
  serializer1tw0a8bv7lkga as serializer_3,
  serializer1q7c5q67ysppr as serializer_4,
  serializer1hu9wv9at41ww as serializer_5,
  serializer3ikrxnm8b29d6 as serializer_6,
  serializerodflzzf6s3fp as serializer_7,
  serializer2lw83vwvpnyms as serializer_8,
  serializer3x9uckd1deom as serializer_9,
  serializer1wpgysz06u9ol as serializer_10,
  serializer345btyh1f2y1j as serializer_11,
  serializer1x79l67jvwntn as serializer_12,
  serializer37oyvz7rc4nep as serializer_13,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import { toList383f556t1dixk as toList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  contextual3hpp1gupsu4al as contextual,
  SerializersModuleCollector3dddz14wd7brg as SerializersModuleCollector,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleCollector.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  ClosedRangeSerializer28fgvycwrq3dm as ClosedRangeSerializer,
  InstantIso8601Serializer_getInstance2pw1uiz054ejd as InstantIso8601Serializer_getInstance,
  LocalDateIso8601Serializer_getInstance3gidjo5oele30 as LocalDateIso8601Serializer_getInstance,
  LocalTimeIso8601Serializer_getInstanceywsvdjhmwgt0 as LocalTimeIso8601Serializer_getInstance,
  LocalDateTimeIso8601Serializer_getInstance302qwxjrznnmc as LocalDateTimeIso8601Serializer_getInstance,
  UUIDSerializer_getInstance2ms0oa88en0c as UUIDSerializer_getInstance,
} from './Serializers.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import {
  BooleanCompanionObject_instance29o5h9ajgjmec as BooleanCompanionObject_instance,
  ByteCompanionObject_instance9rvhjp0l184i as ByteCompanionObject_instance,
  ShortCompanionObject_instance3vq120mx8545m as ShortCompanionObject_instance,
  IntCompanionObject_instance3tw56cgyd5vup as IntCompanionObject_instance,
  FloatCompanionObject_instance367t6x2s4xzmv as FloatCompanionObject_instance,
  DoubleCompanionObject_instance3q51gr7gsd0au as DoubleCompanionObject_instance,
  StringCompanionObject_instance3alxothmy382k as StringCompanionObject_instance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { Companion_getInstance1trnkq9cty7vr as Companion_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import { Companion_getInstance2du03jiluw9jj as Companion_getInstance_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import { Companion_getInstanceuedpedmz4g65 as Companion_getInstance_1 } from '../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import { Companion_instance3skn40jhkoxyn as Companion_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Primitives.mjs';
import { Companion_getInstance1puqqwzccfvrg as Companion_getInstance_2 } from '../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import { Companion_getInstance2e3h8n26rh23 as Companion_getInstance_3 } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Companion_getInstance3vz87v4c01z2t as Companion_getInstance_4 } from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { MonthSerializer_getInstance2qwbrl8lj4d1u as MonthSerializer_getInstance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/MonthSerializers.mjs';
import { TimeZoneSerializer_getInstanceqa9aveo7y5x8 as TimeZoneSerializer_getInstance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/TimeZoneSerializers.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance_0 } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/InstantSerializers.mjs';
import { LocalDateIso8601Serializer_getInstanceny1y5h6nyej8 as LocalDateIso8601Serializer_getInstance_0 } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalDateSerializers.mjs';
import { LocalTimeIso8601Serializer_getInstance1gy7xllc2odvq as LocalTimeIso8601Serializer_getInstance_0 } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalTimeSerializers.mjs';
import { LocalDateTimeIso8601Serializer_getInstance2em1n1hwy5urt as LocalDateTimeIso8601Serializer_getInstance_0 } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalDateTimeSerializers.mjs';
import {
  OffsetDateTimeIso8601Serializer_getInstance3knxddo24n2p4 as OffsetDateTimeIso8601Serializer_getInstance,
  ZonedDateTimeIso8601Serializer_getInstance3j594qymepbka as ZonedDateTimeIso8601Serializer_getInstance,
} from '../ZonedDateTime.mjs';
import { ServerFileSerializer_getInstance2y54t0c6enbya as ServerFileSerializer_getInstance } from '../lightningserver/files/ServerFileSerializer.mjs';
import { GeoCoordinateArraySerializer_getInstance1v36ss1z42d62 as GeoCoordinateArraySerializer_getInstance } from '../GeoCoordinate.mjs';
import {
  TrimOnSerialize_getInstancep6w4pxtjrig1 as TrimOnSerialize_getInstance,
  TrimLowercaseOnSerialize_getInstancepdso2ahq8pnj as TrimLowercaseOnSerialize_getInstance,
  LowercaseOnSerialize_getInstance11cfqc8x5j84m as LowercaseOnSerialize_getInstance,
  TrimmedStringSerializer_getInstance27ofsorf7atqs as TrimmedStringSerializer_getInstance,
  TrimmedCaselessStringSerializer_getInstanceyb3lxczh7nmz as TrimmedCaselessStringSerializer_getInstance,
  CaselessStringSerializer_getInstance1rdo0fmpuy1jg as CaselessStringSerializer_getInstance,
  EmailAddressSerializer_getInstanceu3ltgmcd8ai as EmailAddressSerializer_getInstance,
  PhoneNumberSerializer_getInstance2oi38jtxahgwm as PhoneNumberSerializer_getInstance,
} from '../StringAlts.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { PrimitiveClasses_getInstance2v63zn04dtq03 as PrimitiveClasses_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1hwzc6m64v1op as serializer_14 } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.y3i_1 = false;
        this.z3i_1 = new (SerializationRegistry())(get_ClientModule());
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_5() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
var SerializationRegistry$1Class;
function SerializationRegistry$1() {
  if (SerializationRegistry$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.f4s_1 = this$0;
      }
      c1l(kClass, provider) {
        var tmp = 0;
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_0 = Array(10);
        while (tmp < 10) {
          tmp_0[tmp] = NothingSerializer();
          tmp = tmp + 1 | 0;
        }
        var sample = ContextualSerializer().zy(kClass, null, tmp_0);
        var tmp0 = this.f4s_1.f3j_1;
        var tmp2 = sample.xy_1.h10();
        // Inline function 'kotlin.collections.set' call
        var value = (it) => provider(toList(it));
        tmp0.s3(tmp2, value);
      }
      f1l(baseClass, actualClass, actualSerializer) {
      }
      h1l(baseClass, defaultDeserializerProvider) {
      }
      g1l(baseClass, defaultSerializerProvider) {
      }
    }
    protoOf($).e1l = contextual;
    initMetadataForClass($, VOID, VOID, VOID, [SerializersModuleCollector()]);
    SerializationRegistry$1Class = $;
  }
  return SerializationRegistry$1Class;
}
function SerializationRegistry$lambda(it) {
  return ListSerializer(it[0]);
}
function SerializationRegistry$lambda_0(it) {
  return SetSerializer(it[0]);
}
function SerializationRegistry$lambda_1(it) {
  return MapSerializer(it[0], it[1]);
}
function SerializationRegistry$lambda_2(it) {
  return SetSerializer(it[0]);
}
function SerializationRegistry$lambda_3(it) {
  return MapSerializer(it[0], it[1]);
}
function SerializationRegistry$lambda_4(it) {
  return MapEntrySerializer(it[0], it[1]);
}
function SerializationRegistry$lambda_5(it) {
  return PairSerializer(it[0], it[1]);
}
function SerializationRegistry$lambda_6(it) {
  return TripleSerializer(it[0], it[1], it[2]);
}
function SerializationRegistry$lambda_7(it) {
  return new (ClosedRangeSerializer())(it[0]);
}
var SerializationRegistryClass;
function SerializationRegistry() {
  if (SerializationRegistryClass === VOID) {
    class $ {
      constructor(module_0) {
        Companion_getInstance_5();
        this.d3j_1 = module_0;
        this.e3j_1 = HashMap().n8();
        this.f3j_1 = HashMap().n8();
        this.g3j_1 = HashMap().n8();
        this.d3j_1.t1k(new (SerializationRegistry$1())(this));
        this.h3j(serializer(Unit_instance));
        this.h3j(serializer_0(BooleanCompanionObject_instance));
        this.h3j(serializer_1(ByteCompanionObject_instance));
        this.h3j(serializer_2(Companion_getInstance()));
        this.h3j(serializer_3(ShortCompanionObject_instance));
        this.h3j(serializer_4(Companion_getInstance_0()));
        this.h3j(serializer_5(IntCompanionObject_instance));
        this.h3j(serializer_6(Companion_getInstance_1()));
        this.h3j(serializer_7(Companion_instance));
        this.h3j(serializer_8(Companion_getInstance_2()));
        this.h3j(serializer_9(FloatCompanionObject_instance));
        this.h3j(serializer_10(DoubleCompanionObject_instance));
        this.h3j(serializer_11(Companion_getInstance_3()));
        this.h3j(serializer_12(StringCompanionObject_instance));
        this.h3j(serializer_13(Companion_getInstance_4()));
        this.h3j(MonthSerializer_getInstance());
        this.h3j(TimeZoneSerializer_getInstance());
        this.h3j(InstantIso8601Serializer_getInstance());
        this.h3j(LocalDateIso8601Serializer_getInstance());
        this.h3j(LocalTimeIso8601Serializer_getInstance());
        this.h3j(LocalDateTimeIso8601Serializer_getInstance());
        this.h3j(InstantIso8601Serializer_getInstance_0());
        this.h3j(LocalDateIso8601Serializer_getInstance_0());
        this.h3j(LocalTimeIso8601Serializer_getInstance_0());
        this.h3j(LocalDateTimeIso8601Serializer_getInstance_0());
        this.h3j(UUIDSerializer_getInstance());
        this.h3j(OffsetDateTimeIso8601Serializer_getInstance());
        this.h3j(ZonedDateTimeIso8601Serializer_getInstance());
        this.h3j(ServerFileSerializer_getInstance());
        this.h3j(GeoCoordinateArraySerializer_getInstance());
        this.h3j(TrimOnSerialize_getInstance());
        this.h3j(TrimLowercaseOnSerialize_getInstance());
        this.h3j(LowercaseOnSerialize_getInstance());
        this.h3j(TrimmedStringSerializer_getInstance());
        this.h3j(TrimmedCaselessStringSerializer_getInstance());
        this.h3j(CaselessStringSerializer_getInstance());
        this.h3j(EmailAddressSerializer_getInstance());
        this.h3j(PhoneNumberSerializer_getInstance());
        var tmp = ListSerializer(NothingSerializer()).az().h10();
        this.a3k(tmp, SerializationRegistry$lambda);
        var tmp_0 = SetSerializer(NothingSerializer()).az().h10();
        this.a3k(tmp_0, SerializationRegistry$lambda_0);
        var tmp_1 = MapSerializer(NothingSerializer(), NothingSerializer()).az().h10();
        this.a3k(tmp_1, SerializationRegistry$lambda_1);
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_0 = serializer_14(createKType(getKClass(HashSet()), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false))]), false));
        var tmp_2 = (isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE()).az().h10();
        this.a3k(tmp_2, SerializationRegistry$lambda_2);
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_1 = serializer_14(createKType(getKClass(HashMap()), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false))]), false));
        var tmp_3 = (isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE()).az().h10();
        this.a3k(tmp_3, SerializationRegistry$lambda_3);
        var tmp_4 = MapEntrySerializer(NothingSerializer(), NothingSerializer()).az().h10();
        this.a3k(tmp_4, SerializationRegistry$lambda_4);
        var tmp_5 = PairSerializer(NothingSerializer(), NothingSerializer()).az().h10();
        this.a3k(tmp_5, SerializationRegistry$lambda_5);
        var tmp_6 = TripleSerializer(NothingSerializer(), NothingSerializer(), NothingSerializer()).az().h10();
        this.a3k(tmp_6, SerializationRegistry$lambda_6);
        var tmp_7 = (new (ClosedRangeSerializer())(NothingSerializer())).h4s_1.h10();
        this.a3k(tmp_7, SerializationRegistry$lambda_7);
      }
      h3j(serializer) {
        var tmp0 = this.e3j_1;
        // Inline function 'kotlin.collections.set' call
        var key = serializer.az().h10();
        tmp0.s3(key, serializer);
      }
      a3k(name, make) {
        var tmp0 = this.f3j_1;
        // Inline function 'kotlin.collections.set' call
        var value = typeof make === 'function' ? make : THROW_CCE();
        tmp0.s3(name, value);
      }
      a4s(name, arguments_0) {
        var tmp = this.e3j_1.p3(name);
        var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, KSerializer()) : false) ? tmp : null;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          var tmp1_safe_receiver = this.f3j_1.p3(name);
          var tmp_1 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver(arguments_0);
          tmp_0 = (!(tmp_1 == null) ? isInterface(tmp_1, KSerializer()) : false) ? tmp_1 : null;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        return tmp_0;
      }
    }
    initMetadataForClass($, 'SerializationRegistry');
    SerializationRegistryClass = $;
  }
  return SerializationRegistryClass;
}
//region block: exports
export {
  Companion_getInstance_5 as Companion_getInstance3eoge8j03l9b5,
};
//endregion

//# sourceMappingURL=SerializationRegistry.mjs.map
